// export default {
//   index: {
//     logo: "亿速云",
//     Billing:"账款",
//     Referral:"推荐",
//     Products:"产品",
//     Support:"相关"
//   },
//   menu: {
//     overview: '概览',
//     products: '产品',
//     server: '云服务器',
//     baremetal: '裸金属',
//     mysql: '数据库',
//     elb: '负载均衡',
//     ssl: '证书',
//     ip: 'IP',
//     account: '客户资料',
//     billing: '账单',
//     profile: "我的资料",
//     help: '帮助'
//   }

// }

import common from './common';
import menu from './menu';
import overview from './overview';
import ssl from './ssl';
import mysql from './mysql';
import bms from './bms';
import elb from './elb';
import ecc from './ecc'
import defense from "./defense";
import user from "./user";
import lightserver from "./lightserver";
import referral from "./referral";


export default {
  ...common,
  ...menu,
  ...overview,
  ...ssl,
  ...mysql,
  ...bms,
  ...elb,
  ...defense,
  ...ecc,
  ...user,
  ...overview,
  ...lightserver,
  ...referral
}




// WEBPACK FOOTER //
// ./src/lang/zh-CN/zh-CN.js